module.exports = __webpack_public_path__ + "img/more_restart.c639e331.png";